import { useState } from "react";
import CustomInput from "../CustomInput";
import UploadThumbnailComponent from "../UploadThumbnailComponent";
import { useNavigate } from "react-router-dom";
import ApiService from "../../utils/ApiService";
import useUserStore from "../../stores/store";
import { message } from "antd";

export default function RestaurantEditComponent({
  records = {
    data: {
      restaurantName: "",
      logo: "",
    },
    restaurantId: "",
  },
}) {
  const { user } = useUserStore();
  const navigate = useNavigate();
  const [restaurantName, setRestaurantName] = useState(
    !Boolean(records.data.restaurantName) ? "" : records.data.restaurantName
  );
  const [logoImage, setLogoImage] = useState(
    !Boolean(records.data.logo) ? "" : records.data.logo
  );

  function onHandleCancelRestaurant() {
    navigate("/restaurants");
  }

  function getFormData(dataObj) {
    const formData = new FormData();

    if (typeof dataObj === "object") {
      for (let key in dataObj) {
        if (dataObj.hasOwnProperty(key)) {
            if (!String(dataObj[key]).startsWith('/uploads')) {
                formData.append(key, dataObj[key]);
            }
        }
      }
    }

    return formData;
  }

  async function onHandleUpdateRestaurant() {
    const restaurantUpdatedData = {
      restaurantName: restaurantName,
      logo: logoImage,
    };

    const formData = getFormData(restaurantUpdatedData);

    if (records.restaurantId !== "") {
      const params = {
        restaurantId: records.restaurantId,
        data: formData,
      };

      const token = user.token.token;
      const response = await ApiService.UPDATE_RESTAURANT(params, token);
      if (response.code === 200) {
        message.success(
          restaurantUpdatedData.restaurantName + " restaurant is updated successfully!"
        );
        navigate('/restaurants');
        return;
      }
      message.error("Something went wrong. Please check again later");
    }
  }

  return (
    <section>
      <div className="flex items-center px-[16px]">
        {/* left */}
        <div className="w-[50%]">
          <div className="pb-[20px]">
            <div className="pb-2 font-p_medium font-[12px]">
              Restaurant Name
            </div>
            <CustomInput
              value={restaurantName}
              setValue={setRestaurantName}
              showPadding={false}
              required={false}
              onPressEnter={() => {}}
              maxLength={100}
              placeholder="Restaurant Name"
              inputClasses="indent-5 outline-none h-[48px]"
            />
          </div>
          <div className="pb-[20px]">
            <div className="pb-2 font-p_medium font-[12px]">Logo</div>
            <UploadThumbnailComponent
              key_id="upload-logo"
              placeholderText={"Upload Logo"}
              setImage={setLogoImage}
              prevImage={logoImage}
              deleteParams={{
                modelId: records.restaurantId,
                fieldName: "logo",
                context: "PARENT_RESTAURANT_EDIT",
              }}
            />
          </div>

          <div className="mt-[50px] flex justify-center space-x-[50px]">
            <button
              className="h-[42px] w-[100px] bg-[#FCBD10] text-black text-[14px] font-bold leading-[16px] rounded-lg"
              onClick={onHandleCancelRestaurant}
            >
              Cancel
            </button>

            <button
              className="h-[42px] w-[100px] bg-[#000000] text-white text-[14px] 
          font-bold leading-[16px] rounded-lg"
              onClick={onHandleUpdateRestaurant}
            >
              Save
            </button>
          </div>
        </div>

        {/* right */}
        <div className="w-[50%]"></div>
      </div>
    </section>
  );
}
